import React, { Component } from "react";
import { Col, Container, Row } from "reactstrap";

const tokenUrl = process.env.REACT_APP_TOKEN_URL + "/token";
const apiVersion = process.env.REACT_APP_API_VERSION;
const apiUrl = process.env.REACT_APP_API_URL;
const systemDownMessage = process.env.REACT_APP_SYSTEM_DOWN_MESSAGE;
const version = process.env.REACT_APP_VERSION;
const git_version = process.env.REACT_APP_TEST; //REACT_APP_GIT_SHA;

class Configuration extends Component {
  render() {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="9">
              <div className="clearfix">
                <h1 className="float-left display-3 mr-4">Config</h1>
                <h4 className="pt-3">Settings for Client Portal</h4>
                <p className="text-muted float-left">
                  The following environment variables are being used.
                </p>
              </div>
              <div>
                <Row>
                  <Col sm="6" md="3" className="bg-dark text-white mb-2">
                    Token Url
                  </Col>
                  <Col sm="6" md="8" className="bg-dark text-white mb-2 ml-1">
                    {tokenUrl}
                  </Col>
                </Row>
                <Row>
                  <Col sm="6" md="3" className="bg-secondary mb-2">
                    Api Version
                  </Col>
                  <Col sm="6" md="8" className="bg-secondary mb-2 ml-1">
                    {apiVersion}
                  </Col>
                </Row>
                <Row>
                  <Col sm="6" md="3" className="bg-dark text-white mb-2">
                    Api Url
                  </Col>
                  <Col sm="6" md="8" className="bg-dark text-white mb-2 ml-1">
                    {apiUrl}
                  </Col>
                </Row>
                <Row>
                  <Col sm="6" md="3" className="bg-secondary mb-2">
                    System Down Message
                  </Col>
                  <Col sm="6" md="8" className="bg-secondary mb-2 ml-1">
                    {systemDownMessage}
                  </Col>
                </Row>
                <Row>
                  <Col sm="6" md="3" className="bg-dark text-white mb-2">
                    Version
                  </Col>
                  <Col sm="6" md="8" className="bg-dark text-white mb-2 ml-1">
                    {version}
                  </Col>
                </Row>
                <Row>
                  <Col sm="6" md="3" className="bg-secondary mb-2">
                    Git Version
                  </Col>
                  <Col sm="6" md="8" className="bg-secondary mb-2 ml-1">
                    {git_version}
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Configuration;
